"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _use_row_virtualizer = _interopRequireDefault(require("./use_row_virtualizer"));
function useVirtualization(_ref) {
  var items = _ref.items,
    triggerPaginatedFetch = _ref.triggerPaginatedFetch,
    loadingStatus = _ref.loadingStatus,
    shouldFetchNextPage = _ref.shouldFetchNextPage,
    currentSearchTerm = _ref.currentSearchTerm,
    currentPage = _ref.currentPage,
    setLoadingStatus = _ref.setLoadingStatus;
  var isPaginated = triggerPaginatedFetch;
  return (0, _use_row_virtualizer["default"])(items, {
    fetchItems: function fetchItems() {
      if (isPaginated && currentPage) {
        setLoadingStatus('loading');
        triggerPaginatedFetch(currentSearchTerm, currentPage + 1);
      }
    },
    loadingStatus: loadingStatus,
    more: shouldFetchNextPage,
    isPaginated: !!triggerPaginatedFetch
  });
}
var _default = exports["default"] = useVirtualization;